module.exports = "/_next/static/images/requirements-mobile-97b4b70376db4ae06dffee928bb93d0b.svg";